import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";

const styles = () => ({
  root: {
    fontSize: "8px",
    color: "#B1B3B9",
  },
});

const CorporateNumber = ({ classes, item }) => {
  return (
    <div className={classes.root}>
      法人番号: {item.corporate_number}
    </div>
  );
};

CorporateNumber.propTypes = {
  classes: PropTypes.object.isRequired,
  item: PropTypes.object.isRequired,
};

export default withStyles(styles)(CorporateNumber);



// WEBPACK FOOTER //
// ./src/components/ExecutiveList/Spreadsheet/parts/CorporateNumber.jsx